<style lang="scss" scoped>
.loginInput {
  color: #606266;
}
</style>
<template>
  <el-row class="height_100 flex_m_r">
    <el-col :span="6" class="height_100 login_box white flex_c_m">
      <div class="login_center width_100 flex_tb_c pad60">
        <h2 class="fonts-26 mar_b60">歡迎登入您的管理系統</h2>
        <el-form
          label-width="auto"
          style="width: 260px"
          :ref="(el) => (refState.loginForm = el)"
          :model="formState"
          :rules="rules"
        >
          <el-form-item prop="username" class="width_100">
            <el-input
              placeholder="請輸入你的賬號"
              prefix-icon="el-icon-user-solid"
              type="text"
              class="width_100 loginInput"
              autofocus
              clearable
              v-model="formState.username"
            />
          </el-form-item>
          <el-form-item prop="password" class="width_100">
            <el-input
              placeholder="請輸入你的密碼"
              prefix-icon="el-icon-s-goods"
              type="password"
              class="width_100 loginInput"
              v-model="formState.password"
              clearable
              show-password
            />
          </el-form-item>
          <div class="flex_lr">
            <el-button type="primary" class="flex1" @click="submitForm"
              >登錄</el-button
            >
            <el-button type="info" class="flex1" @click="reset">重置</el-button>
          </div>
        </el-form>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { reactive, getCurrentInstance } from "vue";

export default {
  setup() {
    // variable

    // date
    const formState = reactive({
      username: "",
      password: "",
    });

    // ref
    const refState = reactive({
      loginForm: "",
    });

    // 表单验证
    const validatePass = (rule, value, callback) => {
      // 密碼正則校驗
      if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/.test(value)) {
        callback(new Error("密碼至少包含數字和英文,6-18個字符之間"));
      } else {
        callback();
      }
    };

    const validateUser = (rule, value, callback) => {
      // 賬號正則校驗
      if (!/^[0-9A-Za-z]{5,18}$/.test(value)) {
        callback(new Error("長度在5-18個字符之間"));
      } else {
        callback();
      }
    };

    const rules = {
      username: [
        { required: true, message: "請輸入你的賬號", trigger: "blur" },
        {
          validator: validateUser,
          trigger: "blur",
        },
      ],
      password: [
        { required: true, message: "請輸入你的密碼", trigger: "change" },
        {
          validator: validatePass,
          trigger: "blur",
        },
      ],
    };

    // 生命周期
    /* created */
    const proxy = getCurrentInstance().appContext.config.globalProperties;
    const { $http, $message, $utils } = proxy;

    // methods
    const reset = () => {
      refState.loginForm.resetFields();
    };
    const submitForm = () => {
      // console.log(getCurrentInstance)
      // console.log(ctx)
      refState.loginForm.validate(async (valid) => {
        if (!valid) return;
        const res = await $http.adminLogin(formState);
        if (res.status !== 200) return;
        $message.success("登錄成功");
        proxy.$router.push({
          path: "/",
        });
        $utils.Setcookie("adminId", res.data.adminId);
        $utils.Setcookie("token", res.data.token);
      });
    };

    return {
      formState,
      reset,
      refState,
      rules,
      submitForm,
    };
  },
};
</script>
